import { Box } from '@mui/material';
import { animated, config, useSpring } from '@react-spring/web';
import { PropsWithChildren } from 'react';

export default function AnimatedStepWrapper({ children }: PropsWithChildren) {
  const [springs] = useSpring(() => ({
    from: { y: 100, opacity: 0 },
    to: { y: 0, opacity: 100 },
    config: config.slow,
  }));

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1.5}
      component={animated.div}
      style={springs}
      height={'100%'}
    >
      {children}
    </Box>
  );
}
